module.exports = __webpack_public_path__ + "img/four_circle_gray.ce83ccd3.svg";